import { mapDTO } from '@twistezo/ts-dto-mapper'

import { SortInput } from 'components/Table'
import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import { DomainAlert } from 'features/inventory/domain/types/DomainAlert'
import { DomainsForTable, DomainSortBy } from '../../types'
import { DomainsForTableDTO, DomainSortByDTO } from './types'

type From = DomainsForTableDTO
type To = DomainsForTable

export const domainsFromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((domainForTable: From): To => {
    const { alerts, domainUnfilledRecovery, updatedAt } = domainForTable

    return {
      ...domainForTable,
      alerts: alertsFromDTO<DomainAlert>(alerts),
      domainUnfilledRecovery: {
        baseAdUnitPath: domainUnfilledRecovery.baseAdUnitPath ?? undefined,
      },
      updatedAt: new Date(updatedAt),
    }
  })

export const sortToDTO = (sort: SortInput<DomainSortBy>): SortInput<DomainSortByDTO> => {
  const { by } = sort

  if (by === 'name') {
    return { ...sort, by: 'domainName' }
  } else {
    return { ...sort, by }
  }
}
